<button
  class="root"
  [class.-chosen]="chosen"
  [class.-active]="!disabled"
  [class.-multiline]="multiline"
  [class.-round]="round"
  [class.-spinner]="spinner"
  [class.-has-left-icon]="leftIcon.childNodes.length"
  [class.-has-right-icon]="rightIcon.childNodes.length"
  [ngClass]="['-type-' + type, color ? '-color-' + color : '', size ? '-size-' + size : '']"
  (click)="checkPropagation($event)"
  [attr.type]="htmlType ?? null"
>
  <sky-ui-spinner
    *ngIf="spinner"
    class="spinner"
    [color]="getSpinnerColor()"
    [size]="getSpinnerSize()"
    data-qa-id="spinner-on-sky-ui-button"
  ></sky-ui-spinner>

  <div class="icon -alone">
    <ng-content select="[icon]"></ng-content>
  </div>

  <div class="icon -left" #leftIcon>
    <ng-content select="[iconLeft]"></ng-content>
  </div>

  <div class="text-container">
    <ng-content></ng-content>
  </div>

  <div class="icon -right" #rightIcon>
    <ng-content select="[iconRight]"></ng-content>
  </div>
</button>
